import React, { useState, useEffect } from "react";
import { Spinner, Form } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const handleChange = (e, changeFunction, data) => {
  const valor = data[e.target.selectedIndex].sequencialOrgao;
  changeFunction(valor);
};

const SelectOrgao = ({ formik, field, disabled, onChange }) => {
  const [orgaos, setOrgaos] = useState([]);
  const [showErro, setshowErro] = useState(false);
  const [messageErro, setMessageErro] = useState("");

  const { request, data, errors, isLoading } = useApiClient();

  const objeto = JSON.parse(localStorage.getItem("user"));
  const { cnpjCpf } = objeto;

  useEffect(() => {
    request(apiRoutes.fiscalizacao.parametrizacao.listaOrgao, { cdUsuario: cnpjCpf });
  }, [request, cnpjCpf]);

  useEffect(() => {
    if (data) setOrgaos(data.result);

    if (errors) {
      setMessageErro(errors.message);
      setshowErro(true);
    }
  }, [data, errors]);

  return (
    <>
      {showErro && (
        <>
          <br />
          <div className="alert alert-danger" role="alert">
            {messageErro}
          </div>
        </>
      )}
      {isLoading ? (
        <span>
          <Spinner animation="border" role="status" />
          &bnps;Carregando...
        </span>
      ) : (
        <>
          <Form.Control
            as="select"
            id={field}
            name={field}
            disabled={disabled}
            value={formik.values[field]}
            onChange={(e) => handleChange(e, onChange, orgaos)}
            isInvalid={formik.touched[field] && formik.errors[field]}
          >
            {(orgaos || []).map((item) => (
              <option key={item.sequencialOrgao} value={item.sequencialOrgao}>
                {item.siglaOrgao}
              </option>
            ))}
          </Form.Control>
          {formik.touched[field] && formik.errors[field] && (
            <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
          )}
        </>
      )}
    </>
  );
};

export default SelectOrgao;
